<template>
  <div />
</template>

<script>
// @vuese
// Pusty formularz
// @group ActionData
export default {};
</script>
